enum NotificationType {
    None = '',
    Registration = 'Registration',
    PasswordReset = 'PasswordReset',
    PasswordChanged = 'PasswordChanged',
    ClaimSubmission = 'ClaimSubmission',
    ClaimDisqualification = 'ClaimDisqualification',
    ClaimIncomplete = 'ClaimIncomplete',
    ClaimAdditionalIncomplete = 'ClaimAdditionalIncomplete',
    MailInRegistration = 'MailInRegistration',
    ReferredIndividualConfirmation = 'ReferredIndividualConfirmation',
    ClaimFulfilled = 'ClaimFulfilled',
    CustomerUpdated = 'CustomerUpdated',
    ReadyToRedeem = 'ReadyToRedeem',
}

export default NotificationType;
